<template>
  <figure
    :class="{ 'image-gallery': thumbnail, absolute: absolute }"
    class="wrapper"
  >
    <component
      :is="thumbnail ? 'a' : 'div'"
      :href="`${baseUrl}/${code}.${formats[1] || formats[0]}`"
      target="_blank"
    >
      <lazy-component>
        <picture>
          <template v-for="size in sizes">
            <template v-for="format in formats">
              <source
                :key="size + '_' + format"
                :media="`(max-width: ${size}px)`"
                :srcset="`${baseUrl}/${code}_${size}.${format}`"
                :type="`image/${format}`"
              />
            </template>
          </template>
          <img
            :src="`${baseUrl}/${code}.${formats[0]}`"
            :alt="alt"
            :title="title"
            class="img-responsive"
            @load="onLoad"
          />
          <figcaption v-if="title || description" class="news-main__capture">
            <h1 v-if="title" class="title">
              {{ title }}
            </h1>

            <p v-if="description" class="description">
              {{ description }}
            </p>
          </figcaption>
        </picture>
      </lazy-component>
    </component>
  </figure>
</template>

<script>
export default {
  name: "AppPicture",
  props: {
    code: {
      type: String
    },
    isLegacy: {
      type: Boolean
    },
    thumbFormats: {
      type: String
    },
    thumbSizes: {
      type: String
    },
    description: {
      type: String
    },
    title: {
      type: String
    },
    alt: {
      type: String
    },
    thumbnail: {
      type: [String, Boolean],
      default: false
    },
    absolute: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    baseUrl() {
      if (this.isLegacy) {
        return "https://www.bohemia.net/assets/articles/img/";
      } else {
        return "/app-static/images";
      }
    },
    formats() {
      return this.thumbFormats
        .split(",")
        .sort()
        .reverse();
    },
    sizes() {
      if (this.thumbSizes && this.thumbSizes !== "") {
        return this.thumbSizes
          .split(",")
          .map(size => {
            return parseInt(size);
          })
          .sort((a, b) => {
            return a - b;
          });
      }
      return [];
    }
  },
  methods: {
    onLoad() {
      this.$emit("loaded");
      this.$parent.$emit("loaded");
    }
  }
};
</script>

<style scoped lang="scss">
img {
  width: 100%;
}

.wrapper {
  position: relative;
  margin: 0;
}

.news-main__capture {
  color: #fff;
  bottom: 10px;
}

.title {
  font-size: 1em;
  top: 20px;
  padding: 13px 15px;
}

.description {
  font-size: 0.9em;
  padding: 13px 15px;
}

.absolute {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;
    height: 100%;
    border: 0;
    transform: translate(-50%, -50%);
  }
}
</style>
